var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15521_76157)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80939 13.1903C10.0143 16.3951 12.9833 16.746 13.8547 16.7781C14.9084 16.8169 15.9833 15.9568 16.4478 15.0754C15.7064 14.2053 14.7408 13.5305 13.6827 12.7988C13.0591 13.4224 12.2901 14.581 11.2653 14.1665C10.6833 13.9311 9.24485 13.2687 7.98791 12.0118C6.73092 10.7548 6.06854 9.31629 5.83321 8.73445C5.41836 7.70872 6.57954 6.93831 7.20359 6.31426C6.4723 5.23869 5.80858 4.24836 4.94032 3.54421C4.04747 4.01129 3.18232 5.07796 3.22157 6.14498C3.25364 7.01636 3.60456 9.98545 6.80939 13.1903ZM13.7933 18.4436C12.5926 18.3995 9.19202 17.93 5.63088 14.3688C2.06972 10.8076 1.60022 7.40706 1.55604 6.20627C1.48871 4.37672 2.89021 2.59906 4.50988 1.90492C4.88993 1.74204 5.35026 1.77184 5.71416 2.03729C7.05385 3.01451 7.97814 4.49597 8.77193 5.65597C9.1101 6.15019 9.05427 6.82063 8.62493 7.24998L7.49457 8.38029C7.75692 8.9597 8.29214 9.95895 9.16643 10.8332C10.0407 11.7075 11.0399 12.2427 11.6193 12.5051L12.7491 11.3753C13.1788 10.9456 13.8522 10.889 14.3475 11.2321C15.5308 12.052 16.9206 12.9632 17.9339 14.261C18.2185 14.6255 18.2608 15.1021 18.0911 15.4983C17.3938 17.1255 15.6291 18.5112 13.7933 18.4436Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15521_76157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.b152e70585ebfed9ce37986a7e3928d9.svg";
export { ForwardRef as ReactComponent };